import * as React from 'react';

import InputControlProps from '@/common/InputControlProps';
import Service from '@/lib/App';
import { sortTreeData } from '@/pages/RolloutTab/RolloutEditor/RolloutBlock/ConstraintBlocks/ConstraintBlock/ConstraintValueInput/ConstraintValueInput';
import SelectTreeV2 from '@/pages/RolloutTab/RolloutEditor/RolloutBlock/ConstraintBlocks/ConstraintBlock/ConstraintValueInput/SelectTree/SelectTreeV2';

interface CityTreeSelectV2Props extends InputControlProps {}

const CityTreeSelectV2: React.FC<CityTreeSelectV2Props> = (props) => {
  const treeData = Service.cache!.getCityCountryTreeData(props?.multiple);
  const sortedTreeData = sortTreeData(treeData);

  return (
    <SelectTreeV2
      {...{
        ...props,
        overrideHandleChange: props.onChange,
        treeData: sortedTreeData,
        treeNodeFilterProp: 'title',
        tokenizable: true,
      }}
    />
  );
};

export default CityTreeSelectV2;
